import { cart } from 'src/app/models/cart.model';
import { OauthService } from './oauth.service';
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable quote-props */
import { Injectable, Injector, Type } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';
import { config } from '../confing';

@Injectable({
  providedIn: 'root',
})
export class SyncService {
  constructor(
    private httpclient: HttpClient,
    private oauth: OauthService,
  ) {}

  public sync() {
    const serviceHeaders = this.getHeadersZip();
    const options = { headers: serviceHeaders };
    const requestOptions: object = Object.assign(
      {
        //    reportProgress: true,
        //    observe: 'events',
        responseType: 'blob',
      },
      options,
    );
    return this.httpclient.get(
      `${config[config.env].domain}/api/sync`,
      requestOptions,
    );
  }

  public sendAutorizzazione(payload) {
    /* Header di postman */
    const header = this.getHeadersJson();

    const options = {
      headers: header,
    };

    return this.httpclient.post(
      `${config[config.env].domain}/api/send/resa`,
      payload,
      options,
    );
  }

  public sendOrder(payload) {
    /* Header di postman */
    const header = this.getHeadersJson();
    const options = {
      headers: header,
    };
    /*   return this.httpclient.post(`http://127.0.0.1:8000/api/test/send/order`, payload, options); */
    return this.httpclient.post(
      `${config[config.env].domain}/api/send/order`,
      payload,
      options,
    );
  }

  /**
   * imposta le headers a Zip
   * @returns HttpHeaders
   */
  private getHeadersZip(): HttpHeaders {
    const token = this.oauth.getToken();
    // eslint-disable-next-line max-len
    const header = new HttpHeaders({
      'Content-Type': 'application/zip',
      Accept: 'application/zip',
      Authorization: 'Bearer ' + token,
    });
    return header;
  }

  /**
   * imposta le headers a json
   * @returns HttpHeaders
   */
  private getHeadersJson(): HttpHeaders {
    const token = this.oauth.getToken();
    // eslint-disable-next-line max-len
    const header = new HttpHeaders({
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: 'Bearer ' + token,
    });
    return header;
  }
}
